import { initI18nInstance as e } from "./i18n-init-instance.mjs";
import { createInstance as t } from "i18next";
//#region src/translations/i18n-create-instance.ts
var n = (n) => {
	let r = t();
	return e(r, n);
};
//#endregion
export { n as createI18nInstance };
